import { ReactElement } from 'react';
import {
    Card,
    CardContent,
    CardMedia,
    Paper,
    Typography,
    Skeleton,
    Stack,
    Switch,
    Divider,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@mui/material';
import ampoule from '../../../../assets/images/ampoule.png';
import { ContractGestionAlerteFuiteDto } from '../../../../services/dtos/contract-gestion-alerte-fuite.dto';
import { Warning } from '@mui/icons-material';
import { env } from '../../../../env';

/**
 * Renders a UI component to display a form to update contract preferencies.
 *
 * @param {Object} props - The component properties.
 *
 * @returns {ReactElement} - The rendered contract preferencies UI component.
 */
export default function ContractGestionAlerteFuiteUi(props: {
    loading: boolean;
    gestionAlerteFuite?: ContractGestionAlerteFuiteDto;
    updateGestionAlerteFuite: Function;
}): ReactElement {
    const fuiteDuration = Number(env.REACT_APP_GESTION_ALERTE_FUITE_DUREE);

    const handleSwitchAlerte = () => {
        props.updateGestionAlerteFuite({
            ...props.gestionAlerteFuite,
            alerteFuite: !props.gestionAlerteFuite?.alerteFuite,
        });
    };

    const handleAlerteType = (value: string) => {
        props.updateGestionAlerteFuite({
            ...props.gestionAlerteFuite,
            alerteFuiteTypeContact: parseInt(value),
        });
    };

    let editForm = (
        <>
            <Stack direction="row" spacing={1} alignItems="center">
                <Typography>Voulez-vous être alerté en cas de fuite :</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>Non</Typography>
                    <Switch
                        checked={props?.gestionAlerteFuite?.alerteFuite ?? false}
                        onChange={() => handleSwitchAlerte()}
                    />
                    <Typography>Oui</Typography>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="middle" flexItem />
            {!props.gestionAlerteFuite?.alerteFuite ? (
                <Typography color="red.main" sx={{ mt: 2 }}>
                    <Warning /> L'usager ne pourra bénéficier d'un tarif dégressif s'il ne répond pas dans le délai
                    imparti.
                </Typography>
            ) : (
                <FormControl sx={{ mt: 2 }}>
                    <FormLabel id="demo">Comment souhaitez-vous être alerté ?</FormLabel>
                    <RadioGroup
                        value={props.gestionAlerteFuite.alerteFuiteTypeContact ?? 1}
                        onChange={evt => handleAlerteType(evt.target.value)}
                    >
                        <FormControlLabel
                            value="1"
                            label={`Par email à l'adresse : ${props.gestionAlerteFuite.email}`}
                            control={<Radio />}
                        />
                        {props.gestionAlerteFuite.tel ? (
                            <>
                                <FormControlLabel
                                    value="2"
                                    label={`Par SMS au : ${props.gestionAlerteFuite.tel}`}
                                    control={<Radio />}
                                />
                                <FormControlLabel
                                    value="3"
                                    label={`Les deux : ${props.gestionAlerteFuite.email} / ${props.gestionAlerteFuite.tel}`}
                                    control={<Radio />}
                                />
                            </>
                        ) : (
                            <></>
                        )}
                    </RadioGroup>
                </FormControl>
            )}
        </>
    );

    return (
        <>
            <Card className={'gestionAlerteFuite-card'}>
                <CardMedia
                    component="img"
                    className={'gestionAlerteFuite-img'}
                    src={ampoule}
                    alt="Ampoule-information"
                    sx={{ width: '35% !important' }}
                />
                <CardContent className={'gestionAlerteFuite-content'}>
                    <Typography variant="body1" color="green.main">
                        Une fuite correspond à un écoulement d'eau continu sur une durée de {fuiteDuration} jours.
                    </Typography>
                </CardContent>
            </Card>
            <br></br>
            <Paper className={'container-requests'}>
                {props?.loading ? <Skeleton variant="rectangular" height={250}></Skeleton> : editForm}
            </Paper>
        </>
    );
}
